<template>
  <div class="lucky-page" :style="{ 'backgroundImage': `url(${mh_background})` }" v-cloak>
    <div class="my-body">
      <div
        class="heightBG"
        :style="{ height: boxHeightRem + 'rem' }"
      >
        <div class="top-back">
          <div class="top-login-box">
            <div class="not-login" @click="logFun" v-if="!isLogin">
              <div data-text="登录" >登录</div>
            </div>
            <div class="logined" v-else>
                <div class="name">
                  <span>
                    <a-icon type="user"  class="icon-before" style="font-size: x-small;" />
                  </span>
                  <span :data-full-text="info.username" @click="toggleText">{{ truncateText(info.username) }}</span>
                </div>
                <div class="logout" @click="logOut"></div>
            </div>
          </div>
          <img :src="mh_logo" class="logoImg" v-if="mh_logo" />
        </div>
        <div style="height: 160px;" class="jimeng-box">
          <img src="~@/assets/jimeng.png" alt="">
        </div>
        <div class="hegithBottom">
           <div class="mh-box">
            
            <div class="gift-box">
            <div class="row clearfix">
              <div :class="['column', `col-${index + 1}`]" v-for="(_, index) in 6" :key="index" @click="spinFun">
                <div class="column-header">
                    <img src="~@/assets/border.png" alt="">
                </div>
               </div>
            </div>
          </div>

            <div class=" login-box">
                <div v-if="isLogin" class="remain-count">剩余&nbsp;{{ remain || 0 }}&nbsp;次</div>
            </div>

           </div>
        </div>
      </div>

     <!-- 底部 -->
      <div class="bottom-box">
        <div class="bottom-box-top">
          <div @click="logFun">抽奖记录</div>
          <div>
            <a :href="onLink" target="_bank">联系客服</a>
          </div>
        </div>
      </div>
    </div>


    <loading
      v-show="loading"
      class="loadingClass"
    />
    <transition name="fade">
      <Login v-show="showLoginModal" @close="closeModal" @customAlert="customAlert"/>
    </transition>
    <transition name="fade">
        <Final 
        v-show="showFinalModal"
         @close="closeModal"
          :amount="amount" 
          :prizeImg="prizeImg" 
          :isWin="isWin"/>
    </transition>
    <transition name="fade">
        <DrawTimes v-if="showLogModal" @close="closeModal"/>
    </transition>   
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from './LoadingModule.vue'
import DrawTimes from './DrawTimes.vue';
import Final from './FinalModule.vue';
import Login from './LoginModule.vue';
export default {
  data() {
    return {
      giftArr: [],
      remain: 0,
      showLoginModal: false, // 是否登录
      isLogin: false,
      showFinalModal: false,  // 抽奖弹框
      showLogModal: false, // 抽奖记录弹框
      onLink: '',
      info: '',
      amount: '', // 结果
      isWin: false,
      mh_logo: '',
      mh_background: '',
      prizeImg: ''
    };
  },
  computed: {
    ...mapGetters(['loading']),
    boxHeightRem() {
      return this.innerHeightRem;
    },
  },
  components: {
    Loading,
    Login,
    Final,
    DrawTimes
  },
  mounted() {
    this.siteInitFun()
    this.checkActivityFun()
    this.poolFun()
    let _info = sessionStorage.getItem('info')
    if (_info) {
      this.getDetailFun()
    }
  },
  methods: {
    customAlert(content, title, width, top) {
      if (content == undefined) {
        content = "";
      }
      if (title == undefined) {
        title = "温馨提示";
      }
      if (width == undefined) {
        width = "360px";
      }
      if (top == undefined) {
        top = "50%";
      }
      this.$modal.confirm({
        title: title,
        content: content,
        okText: '确定',
        cancelText: '取消'
      });
    },
    closeModal(visible) {
      if (visible === 'showLoginModal') {
        let _info = sessionStorage.getItem('info')
        if (_info) {
          this.isLogin = true
          this.info = JSON.parse(_info)
          this.remain = this.info.total_draw_times
        }
      }
      this[visible] = false
    },
    async poolFun() {
      this.$store.dispatch('SET_LOADING', true)
      await this.$axios.post("/MHWinningPool/getAllList", {}).then(r => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { list } = r.data.data
            this.giftArr = list
          } else this.errorFun(msg)
        }
      }).catch(() => {
      });
      this.$store.dispatch('SET_LOADING', false)
    },
    async siteInitFun() {
      this.$store.dispatch('SET_LOADING', true)
      await this.$axios.post("/Site/init", {}).then(r => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { cs_url, mh_logo, mh_background } = r.data.data
            this.onLink = cs_url
            if (mh_background) {
              this.mh_background = `${this.$Domain}${mh_background}`
            }
            if (mh_logo) {
              this.mh_logo = `${this.$Domain}${mh_logo}`
            }
            this.handleIcoCreate(r.data.data)
          } else this.errorFun(msg)
        }
      }).catch(() => {
      });
      this.$store.dispatch('SET_LOADING', false)
    },
    handleIcoCreate(siteObj) {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = `${this.$Domain}${siteObj.mh_logo}`
      let head = document.head || document.getElementsByTagName('head')[0]
      head.appendChild(link);
      let title = document.createElement('title')
      title.innerHTML = siteObj.name
      head.appendChild(title);
    },
    async checkActivityFun() {
      this.$store.dispatch('SET_LOADING', true)
      return await this.$axios.post("/MHUser/checkActivity", {}).then(r => {
        if (r.status === 200) {
          const { status, msg } = r.data
          var isActive = false
          if (status) {
            const { start_time, end_time } = JSON.parse(r.data.data.setting)
            if (new Date().getTime() < start_time * 1000) {
              this.errorFun('活动还未开始')
              isActive = false
            } else if (end_time * 1000 < new Date().getTime()) {
              this.errorFun('活动已结束')
              isActive = false
            } else isActive = true
          } else {
            this.errorFun(msg)
            isActive = false
          }
        }
        this.$store.dispatch('SET_LOADING', false)
        return isActive
      }).catch(() => {
        this.$store.dispatch('SET_LOADING', false)
      });
    },
    async spinFun() {
      // 检查活动时间
      if (! await this.checkActivityFun()) return
      if (!this.isLogin) return this.showLoginModal = true
      if (this.remain < 1) return this.errorFun('次数已经用完了')
      this.$store.dispatch('SET_LOADING', true)
      await this.$axios.post('/MHUser/spin', { username: this.info.username }).then((r) => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { total_draw_times, winning_pool_id, winning_pool_is_win, winning_pool_title } = r.data.data
            this.remain = total_draw_times
            if (winning_pool_is_win) {
              this.isWin = true
              this.amount = winning_pool_title
              this.giftArr.map((item) => {
                if (item.id === winning_pool_id) {
                  this.prizeImg = item.img
                }
              })
              this.showFinalModal = true
            } else this.customAlert(winning_pool_title)
          } else this.errorFun(msg)
        }
        this.$store.dispatch('SET_LOADING', false)
      }).catch(() => {
        this.$store.dispatch('SET_LOADING', false)
      })
    },
    async getDetailFun() {
      this.$store.dispatch('SET_LOADING', true)
      let username = this.userNameFun()
      if (!username) return
      await this.$axios.post('/MHUser/getDetail', { username: username }).then((r) => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            this.isLogin = true
            sessionStorage.setItem('info', JSON.stringify(r.data.data))
            this.info = r.data.data
            this.remain = r.data.data.total_draw_times
          } else this.errorFun(msg)
        }
      })
      this.$store.dispatch('SET_LOADING', false)
    },
    userNameFun() {
      let _info = sessionStorage.getItem('info')
      if (_info) {
        this.isLogin = true
        let temp = JSON.parse(_info)
        return temp.username
      }
      return ''
    },
    logFun() {
      if (!this.isLogin) {
        this.showLoginModal = true
      } else this.showLogModal = true
    },
    errorFun(msg) {
      this.$message.error(msg)
    },
    logOut() {
      sessionStorage.clear();
      location.reload();
    },
    truncateText(text) {
      if(!text) return
      const maxLength = 8;
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    },
    toggleText(element) {
      const span = element.currentTarget
      const fullText = span.getAttribute('data-full-text');
      // Check if the current text ends with "..."
      if (span.textContent.endsWith('...')) {
        // If it's truncated, show the full text
        span.textContent = fullText;
      } else {
        // If it's not truncated, show the truncated version
        span.textContent = this.truncateText(fullText);
      }
    }
  },

  watch: {
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}

p {
  margin: 0;
  padding: 0;
}

a {
  color: #fff;
}

::-webkit-scrollbar {
  width: 0 !important;
}


.lucky-page {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #FB9760;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;

  .my-body {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  @media (max-width: 576px) {
    .bottom-box {
      position: fixed;
      bottom: 0;
    }
  }

  .bottom-box {
    width: 3.75rem;
    height: .44rem;
    line-height: .44rem;
    flex-shrink: 0;


    .bottom-box-top {
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-content: center;

      >div {
        width: 40%;
        text-align: center;
        color: #FFF;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        background: url(~@/assets/btn.png) no-repeat center top / 100% auto;
      }

      span {
        color: #FFF;
      }
    }
  }

  p {
    margin: 0;
    padding: 0;
  }

  .heightBG {
    position: relative;
    width: 100%;
    background-size: 100% 100%;

    img {
      object-fit: contain;
    }

    .top-back {
      height: .8rem;
      text-align: center;

      .top-login-box {
        padding-top: 10px;
        padding-right: 10px;
        padding-bottom: 10px;
        display: flex;
        justify-content: flex-end;
      }

      .not-login {
        width: 101px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        background: url(~@/assets/not.png) no-repeat center top;
        background-size: 100% auto;


        div {

          font-family: 'Signika Negative SC';
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          text-transform: capitalize;

          /* 渐变文字 */
          background: linear-gradient(179.82deg, #8E0001 0.15%, #FA0104 59.05%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;

          /* 布局 */
          display: inline-flex;
          align-items: flex-end;
          position: relative;
          padding: 5px;
          /* 给边框留出空间 */

        }

        div::before {
          content: attr(data-text);
          position: absolute;
          top: 5px;
          left: 0;
          right: 0;
          bottom: 0;
          /* 边框效果 */
          color: transparent;
          -webkit-text-stroke: 0.3px rgba(255, 255, 255, 0.7);
          text-stroke: 0.3px rgba(255, 255, 255, 0.7);
        }





      }

      .logined {
        color: #fff;
        display: flex;
        align-content: center;
        gap: 10px;

        .name {
          box-sizing: border-box;
          min-width: 109px;
          height: 34px;
          line-height: 34px;
          padding: 0 10px;
          background: rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-radius: 100px;

          span:first-child {
            display: inline-block;
            width: 18px;
            height: 18px;
            line-height: 16px;
            text-align: center;
            border-radius: 50%;
            background-color: #d41d13;
          }
        }
        span:last-child{
          padding-left: 5px;
        }
      }

      .logout {
        width: 38px;
        height: 38px;
        background: url(~@/assets/out.png) no-repeat center top;
        background-size: 100% auto;
      }

      img {
        display: inline-block;
        width: 1rem;
        height: auto;
        vertical-align: text-top;
      }
    }

    .jimeng-box {}
  }

  .hegithBottom {
    width: 100%;
    padding-bottom: 1em;

    .mh-box {
      margin-top: -.65rem;
      height: 4.92rem;
      background: url(~@/assets/gift.png) center top no-repeat;
      background-size: 100% auto;

      .gift-box {
        padding-top: 1.55rem;
        text-align: center;
      }

      .row {
        width: 84%;
        display: inline-block;
        vertical-align: middle;
        line-height: normal;
        /* 清除浮动 */
        overflow: hidden;
      }

      .column {
        width: 32%;
        margin-right: 2%;
        float: left;
        border-radius: 5px;
        overflow: hidden;
        // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
      }

      .column:nth-child(-n+3) {
        margin-bottom: .1rem;
      }

      /* 每行的最后一列 */
      .column:nth-child(3n) {
        margin-right: 0;
      }

      .column-header {
        text-align: center;

        img {
          display: inline-block;
          width: 100%;
        }
      }

      /* 清除浮动 hack */
      .clearfix:after {
        content: "";
        display: table;
        clear: both;
      }

      .login-box {
        margin-top: .6rem;
        clear: both;
      }

    }



    .remain-count {
      margin: 0 auto;
      text-align: center;
      font-family: MicrosoftYaHei;

      border: 1px solid;


      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.80);
      background: rgba(191, 0, 26, 0.60);
      min-width: .96rem;
      max-width: max-content;
      padding: 0 .1rem;
      height: .32rem;
      line-height: .32rem;

      color: #FFF;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 15px;
      font-style: normal;
      font-weight: 500;


    }

    .click-toLink {
      width: 76%;
      height: 0.82rem;
      padding: 0 0.3rem;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      // background: url(../assets/img/bigWheel/m_click_bottom.png) no-repeat;
      background-size: 100% 100%;

      div {
        height: 0.4rem;
        margin: auto 0;
      }

      .win-record {
        // background: url(../assets/img/bigWheel/m_win_record.png) no-repeat;
        background-size: 100% 100%;
      }

      .buy-point {
        // background: url(../assets/img/bigWheel/m_buy_point.png) no-repeat;
        background-size: 100% 100%;
      }

      .show-rules {
        // background: url(../assets/img/bigWheel/m_rules.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }

}
</style>
